import { render } from "./InputLabel.vue?vue&type=template&id=f84c7634&scoped=true"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"

import "./InputLabel.vue?vue&type=style&index=0&id=f84c7634&scoped=true&lang=css"

import exportComponent from "C:\\projects\\epd-cnmp-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84c7634"]])

export default __exports__